import gql from 'graphql-tag';

export const QUERY_PRODUCTS_CATEGORIES = gql`
  query ProductCategories {
    searchProductCategories {
      id
      name_en
      name_de
      slug
      image {
        url
        formats
      }
    }
    # productsCount(outputChannel: $outputChannel)
  }
`;

export const QUERY_PRODUCTS_CATEGORIES_COUNT = gql`
  query ProductCategoriesCount($outputChannel: String!) {
    productsCount(outputChannel: $outputChannel)
  }
`;
